import React, { useState } from "react";
import {
  Button,
  Icon,
  Modal,
  Popup,
  TransitionablePortal,
} from "semantic-ui-react";
import { guidelineVideo } from "../../utils/consts";

const SignUpGuideLine = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Popup
        content="YouTube Video"
        trigger={
          <div className="youtube-link" onClick={() => setOpen(true)}>
            <Icon name="youtube" />
            <p>Quick walk-through of signup process</p>
          </div>
        }
      />
      <TransitionablePortal
        transition={{ animation: "slide left", duration: "500" }}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Modal open={true} className="youtube-modal">
          <Modal.Content>
            <div className="AdminTopButtonsContainer">
              <Button
                floated="left"
                circular
                icon="close"
                onClick={() => setOpen(false)}
              />
            </div>
            <iframe
              src={guidelineVideo}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    </>
  );
};

export default SignUpGuideLine;
